import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
 
const SearchableDropDown = ({
  options,
  control,
  name = "filter",
  defaultValue = null,
  onSelect,
  ddname = "name",
  setfirst,
  forCountry=false,
  value
}) => {

  const {
    register,
    control: control2,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    mode: "all",
    defaultValues: {
      [name]: defaultValue,
    },
  });

  console.log(value,"value");
 

  const [searchInput, setSearchInput] = useState("");
  const filteredOptions = options?.filter((item) =>
  // item[ddname] === 'country' ? 'country' : ddname
    item[ddname]?.toLowerCase()?.includes(searchInput?.toLowerCase())
);  


  return (
      <Controller
          control={control ? control : control2}
          name={name}
          render={({ field, onChange }) => (
              <Dropdown
                  id="dropdown-basic-button"
                  drop="down-centered"
                  onSelect={(e) => {
                      onSelect(JSON.parse(e))
                      field.onChange(JSON.parse(e))
                      if (typeof setfirst === 'function') {
                          onSelect(e)
                          setfirst(JSON.parse(e))
                      }
                  }}
              >
                {
                    console.log(field.value,"field.value")
                }
                  <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="icontrol"
                  >
                      {field.value?.[ddname] ||'Select'}
                      {/* {value.name || "select"} */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                      <input
                          type="text"
                          placeholder="Search..."
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                      />
                      {filteredOptions?.length === 0 && (
                          <Dropdown.Item disabled>
                              No result found
                          </Dropdown.Item>
                      )}
                      {filteredOptions?.map((list, index) => {
                          return(
                          <Dropdown.Item
                              key={index}
                              eventKey={JSON.stringify(list)}
                              className={
                                  field.value?.[ddname] === list?.[ddname]
                                      ? 'active'
                                      : ''
                              }
                          >
                              {list?.[ddname]}
                          </Dropdown.Item>
                          )
                      })}
                  </Dropdown.Menu>
              </Dropdown>
          )}
      />
  )
};

export default SearchableDropDown;
